import { DialogV2 } from '@recruit-robin/robin-theme/web-components';
import { useEffect, useMemo } from 'react';
import { InterviewType } from '../../model';
import { Body, Footer, Header } from './dialog';
import { InterviewValue } from './InterviewTypeSelection.types';
import { useInterviewTypeSelection } from './useInterviewTypeSelection';
import { useGetNylasConnectionStatusQuery } from '../../api';

type InterviewTypeSelectionProps = {
  initialInterviewType?: InterviewType;
  onConfirm?: (value: InterviewType, interviewValue: InterviewValue) => void;
  footer?: React.ReactNode;
  showOnlineOption?: boolean;
};

export const InterviewTypeSelection = ({ initialInterviewType, onConfirm, footer }: InterviewTypeSelectionProps) => {
  const {
    selectedInterviewType,
    setSelectedInterviewType,
    interviewValue,
    setInterviewValue,
    errors,

    handleValidateAndSave,
    schedulerConfigIsFetching,
    isSaving,
    schedulerConfig,
  } = useInterviewTypeSelection({ initialInterviewType, onConfirm });
  const { data: nylasConnectionStatus } = useGetNylasConnectionStatusQuery();
  const showOnlineOption = useMemo(
    () => nylasConnectionStatus?.calendar?.has_online_meetings_authorization !== false,
    [nylasConnectionStatus],
  );

  useEffect(() => {
    if (!showOnlineOption && selectedInterviewType === InterviewType.Online) {
      setSelectedInterviewType(InterviewType.Call);
    }
  }, [showOnlineOption, selectedInterviewType, setSelectedInterviewType]);

  return (
    <>
      <Header />
      <DialogV2.Body>
        <Body
          schedulerConfig={schedulerConfig}
          selectedInterviewType={selectedInterviewType}
          onSelectedInterviewType={setSelectedInterviewType}
          interviewValue={interviewValue}
          setInterviewValue={setInterviewValue}
          error={errors}
          isLoadingInitialData={schedulerConfigIsFetching}
          showOnlineOption={showOnlineOption}
        />
      </DialogV2.Body>
      <Footer
        hasSelection={!!selectedInterviewType}
        onConfirm={handleValidateAndSave}
        isSaving={isSaving}
        footer={footer}
      />
    </>
  );
};
